/**
 * Registers a simple filled Konva `Rect` for registry key {@link FLOOR_PLAN_SHAPE_KEY_FALLBACK_RECT}
 * (`fallback:rect`). That key is returned by {@link resolveFloorPlanShapePaintKey} for element kinds
 * that are not bar / architecture / furniture (e.g. a future subclass), and is also used in
 * `nodes/floor-plan-element-nodes` when no painter was found for the resolved key — so something visible
 * still draws instead of an empty group with only the hit area.
 */
import {
  floorPlanInnerStrokeAttrs,
  FLOOR_PLAN_SHAPE_KEY_FALLBACK_RECT,
  registerFloorPlanShapePainter,
} from './paint';

registerFloorPlanShapePainter(FLOOR_PLAN_SHAPE_KEY_FALLBACK_RECT, (ctx) => {
  const { K, group, widthPx: w, heightPx: h, theme, innerStrokeUsesSelection } = ctx;
  const { stroke, strokeWidth } = floorPlanInnerStrokeAttrs(theme, innerStrokeUsesSelection);
  group.add(
    new K.Rect({
      x: 0,
      y: 0,
      width: w,
      height: h,
      fill: theme.elementFill,
      stroke,
      strokeWidth,
      listening: false,
    }),
  );
});
